import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { computed, onMounted, watch } from 'vue'

    import { useStartupDetailsQueryV1 } from '@Organizations/Users/queries-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StartupPage',
  setup(__props) {

    const { runStartupDetailsQueryV1,
        modelStartupDetailsQueryV1: startupDetails } = useStartupDetailsQueryV1();

    onMounted(() =>
    {
        runStartupDetailsQueryV1()
    })

    watch(startupDetails, (details) =>
    {
        if (details?.Url)
        {
            location.href = details.Url
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("br", null, null, -1 /* CACHED */),
    _createElementVNode("h1", null, "Loading...", -1 /* CACHED */)
  ]))]))
}
}

})